import { Box, Text } from '@chakra-ui/react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import React, { ReactElement } from 'react';
import { Breakpoints } from 'types/breakpoints';
import { ModalTagVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalTagVariantProps;

export const TagModal = ({ handleClose, isShown, title, tagDescription }: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);

  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleClose}
      size="md"
      placement={isDesktop ? 'center' : 'bottom'}
      borderRadius={isDesktop ? undefined : '10px 10px 0 0'}
      title={title}
    >
      <CustomModalContent p="0">
        <Box p={{ base: '15px 20px 40px', md: '25px 20px' }}>
          {tagDescription?.map(({ value }) => (
            <Box key={value}>
              <Text textStyle="body.m.regular" color="text.tertiary">
                {value}
              </Text>
            </Box>
          ))}
        </Box>
      </CustomModalContent>
    </CustomModal>
  );
};
